import React, { useEffect, useState } from "react";
import { Breadcrumb, SimpleCard } from "@gull";
import { Formik } from "formik";
import { Helmet } from "react-helmet";
import { model, validationModel } from "./addIpUtility";
import { RenderCheckboxInput, RenderTextInput } from "app/common/renderInput";
import { addIP, editIP, getIPById } from "app/services/ipService";
import { NotificationManager } from "react-notifications";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import MemberAutoComplete from "./MemberAutocomplete";

function EditIpVendor() {
  const params = useParams();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [modelState, setModelState] = useState({}); // Initialize as empty object
  const [formState, setFormState] = useState({});

  // Fetch IP Vendor Details
  const getModel = async () => {
    try {
      const response = await getIPById(params.id);
      if (response?.data?.data) {
        setModelState(response.data.data);
        setFormState({
          id: response.data.data.id,
          memId: response.data.data.memId,
          ipAddress: response.data.data.ipAddress,
          macIPAddress: response.data.data.macIPAddress,
          domainName: response.data.data.domainName,
          status: response.data.data.status,
        });
      } else {
        NotificationManager.error("IP Vendor not found");
        navigate("/admin/ip-vendor");
      }
    } catch (error) {
      NotificationManager.error("Error fetching data");
    }
  };

  useEffect(() => {
    if (params.id) getModel();
  }, [params.id]);

  // Handle Form Submission
  const handleSubmit = async (values) => {
    setShow(true);
    try {
      const res = await addIP(values);
      if (res.status === "Success") {
        NotificationManager.success(res.message);
        navigate("/admin/ip-vendor");
      } else {
        NotificationManager.error(res.message);
      }
    } catch (error) {
      NotificationManager.error("Failed to update IP Vendor");
    } finally {
      setShow(false);
    }
  };

  return (
    <div>
      <Helmet>
        <title>Update IP Vendor</title>
      </Helmet>
      <Breadcrumb
        routeSegments={[
          { name: "IP Vendor List", path: "/admin/ip-vendor" },
          { name: "Update IP Vendor" },
        ]}
      />
      <div>
        {Object.keys(formState).length !== 0 && (
          <Formik
            initialValues={formState}
            validationSchema={validationModel}
            onSubmit={handleSubmit}
            enableReinitialize={true} // Ensures form updates when state changes
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => {
              // Correctly placed useEffect to avoid errors
              // useEffect(() => {
              //   if (modelState?.memId) {
              //     setFieldValue("memId", modelState.memId);
              //   }
              // }, [modelState, setFieldValue]);
              return (
                <form
                  className="needs-validation"
                  onSubmit={handleSubmit}
                  noValidate
                >
                  <div className="row">
                    <div className="col-lg-12 col-md-12">
                      <SimpleCard title="Personal Details" className="mb-4">
                        <div className="row">
                          <MemberAutoComplete
                            setFieldValue={setFieldValue}
                            handleChangeOptions={(value) => {
                              const selectedMemberId = value.id;
                              setFieldValue("memId", selectedMemberId);
                            }}
                            name="memId"
                            value={values.memId}
                            modelState={modelState}
                          />
                          {!values.memId ? (
                            <p className="text-danger">{errors.memId}</p>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="row">
                          <RenderTextInput
                            type="text"
                            name="ipAddress"
                            display="Ip Address"
                            placeholder="Ip Address"
                            value={values.ipAddress}
                            error={errors.ipAddress}
                            onChange={(e) => {
                              handleChange(e);
                            }}
                            onBlur={handleBlur}
                            touched={touched.ipAddress}
                            required
                          ></RenderTextInput>
                        </div>

                        <Row className="mb-3">
                          <Col sm={12} xs={12} lg={6} md={6} xl={6}>
                            <RenderTextInput
                              type="text"
                              name="macIPAddress"
                              display="MAC IP Address"
                              placeholder="MAC IP Address"
                              value={values.macIPAddress}
                              error={errors.macIPAddress}
                              onChange={(e) => {
                                handleChange(e);
                              }}
                              onBlur={handleBlur}
                              touched={touched.macIPAddress}
                              required
                            ></RenderTextInput>
                          </Col>
                          <Col sm={12} xs={12} lg={6} md={6} xl={6}>
                            <RenderTextInput
                              type="text"
                              name="domainName"
                              display="Domain Name"
                              placeholder="Domain Name"
                              value={values.domainName}
                              error={errors.domainName}
                              onChange={(e) => {
                                handleChange(e);
                              }}
                              onBlur={handleBlur}
                              touched={touched.domainName}
                              required
                            ></RenderTextInput>
                          </Col>
                        </Row>

                        <div className="row">
                          <RenderCheckboxInput
                            type="switch"
                            name="status"
                            display="Active"
                            value={values.status ? values.status : ""}
                            error={errors.status}
                            onChange={(e) => {
                              setFieldValue("status", e.currentTarget.checked);
                            }}
                            onBlur={handleBlur}
                            touched={touched.status}
                          ></RenderCheckboxInput>
                        </div>
                      </SimpleCard>
                    </div>
                  </div>

                  {/* Submit Button with Spinner */}
                  {show ? (
                    <Button variant="primary" disabled>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        style={{ marginRight: "10px" }}
                      />
                      Saving...
                    </Button>
                  ) : (
                    <Button variant="primary" type="submit">
                      Update
                    </Button>
                  )}
                </form>
              );
            }}
          </Formik>
        )}
      </div>
    </div>
  );
}

export default EditIpVendor;
